import React from 'react';
import styled from 'styled-components';
import Gravatar from 'react-gravatar';
import PageHeader from '../Header/PageHeader';
import Mobile from '../../assets/svgs/Mobile';
import Phone from '../../assets/svgs/Phone';
import Envelope from '../../assets/svgs/Envelope';

const UserPage = ({ className, history }) => {
    const { ticket } = history.location.state;
    return (
        <div className={className}>
            <PageHeader title="حساب کاربری" />
            <div className="User__Info">
                <Gravatar email={ticket.email} />
                <h3>{`${ticket.last_name} ${ticket.name}`}</h3>
                <div className="User__Mobile">
                    <Mobile />
                    <span>{ticket.mobile}</span>
                    <a class="phone" href={`tel:${ticket.mobile}`}>
                        <Phone />
                    </a>
                </div>
                <div className="User__Email">
                    <Envelope />
                    <a class="email" href={`mailto:${ticket.email}`}>
                        {ticket.email}
                    </a>
                </div>
                <div className="User__Code">
                    <span>{ticket.au}</span>
                </div>
            </div>
        </div>
    );
};

export default styled(UserPage)`
    .User__Info {
        padding: 0 35px;
        img {
            width: 56px;
            height: 56px;
            display: block;
            margin: 35px auto 15px auto;
            border-radius: 50%;
        }

        h3 {
            font-size: 18px;
            font-weight: bold;
            line-height: 31px;
            color: #0d1fa1;
            text-align: center;
        }

        .User__Mobile,
        .User__Email,
        .User__Code {
            padding: 13px 17px;
            display: flex;
            background: #fff;
            box-shadow: 0 2px 4px rgba(100, 106, 147, 0.05);
            border-radius: 5px;
            margin-top: 32px;
            text-align: left;
            direction: ltr;
            align-items: center;
            position: relative;

            span {
                font-size: 14px;
                font-weight: bold;
                line-height: 25px;
                color: rgba(13, 31, 161, 1);
            }

            > svg {
                margin-right: 8px;
            }

            .phone {
                width: 32px;
                height: 32px;
                background: rgba(18, 199, 109, 1);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                right: 18px;
                top: 50%;
                transform: translateY(-50%);
            }
        }

        .User__Email,
        .User__Code {
            margin-top: 16px;

            .email {
                font-size: 14px;
                font-weight: bold;
                line-height: 25px;
                color: #0d1fa1;
            }
        }
    }
`;
